/* ============================================================
   RUNSPIRE — Customizações do carrinho.
   Funciona em DOIS lugares:
     - gaveta lateral  (#CartDrawer)
     - página /cart    (#main-cart-footer)

   O que injeta:
   1) Prazo de entrega por CEP (v28): mostra o frete (R$12 ou grátis),
      a região e os dias úteis. Na gaveta e no /cart é uma linha recolhida;
      na página de produto fica aberto, no bloco .rs-frete-slot, com o
      "frete grátis a partir de R$165" como subtítulo.
   2) Campo de cupom RECOLHIDO (v28): "Tem um código ou cupom?" abre ao clicar.
      Aplica via desconto Shopify, total real.
   3) Total estimado riscado quando há QUALQUER desconto —
      cupom digitado OU desconto automático (a escada).

   Na gaveta, prazo e cupom entram logo depois dos produtos (fora do
   rodapé), assim o rodapé com total e finalizar fica só com o essencial.

   Histórico:
   - Upsell "Você também vai amar" removido em 17/07/2026.
   - Barra de frete grátis ("2 itens") REMOVIDA em 04/08/2026:
     a regra nunca foi por quantidade, sempre por VALOR (R$165).
     Substituída pelo snippet 'rs-ladder-progress'.

   Elementos injetados usam CLASSE (.rs-coupon), não id, porque
   na /cart a gaveta e a página coexistem no DOM.
   ============================================================ */
(function () {
  var observers = [];
  var appliedCode = null;
  var couponOpen = false;
  var freteOpen = false;
  var CHEV = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';

  function fmtBRL(cents) {
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function moneyAfterRS(str) {
    var m = (str || '').match(/R\$\s*([\d.,]+)/);
    if (!m) return 0;
    var v = parseFloat(m[1].replace(/\./g, '').replace(',', '.'));
    return isNaN(v) ? 0 : Math.round(v * 100);
  }

  function roots() {
    var list = [];
    var drawer = document.querySelector('#CartDrawer');
    if (drawer) list.push(drawer);
    var page = document.querySelector('#main-cart-footer');
    if (page) list.push(page);
    return list;
  }

  /* ---------- Total riscado ---------- */
  function injectTotalStrike(root) {
    var totalEl = root.querySelector('.totals__total-value');
    if (!totalEl || totalEl.querySelector('.rs-total-strike')) return;
    var newC = moneyAfterRS(totalEl.textContent);
    var discC = 0;
    root.querySelectorAll('.discounts__discount').forEach(function (li) { discC += moneyAfterRS(li.textContent); });
    if (!newC || !discC) return;
    totalEl.innerHTML = '<s class="rs-total-strike" style="color:#8fa4b2;font-weight:500;margin-right:8px;">' + fmtBRL(newC + discC) + '</s>' + fmtBRL(newC);
  }

  /* ---------- Prazo de entrega por CEP ----------
     O frete é único (R$12, grátis a partir de R$165) e não depende do CEP;
     o CEP só define a região e, com ela, o prazo. Prazos por região: os mesmos
     do bloco "Entrega e frete" da página de produto. Se mudar o frete no
     Shopify (perfil de envio), mude FREE_FROM e FREIGHT aqui. */
  var CEP_KEY = 'rs_cep';
  var FREE_FROM = 16500;
  var FREIGHT = 'R$ 12,00';
  function readCep() { try { return localStorage.getItem(CEP_KEY) || ''; } catch (e) { return ''; } }
  function saveCep(v) { try { if (v) localStorage.setItem(CEP_KEY, v); else localStorage.removeItem(CEP_KEY); } catch (e) { /* sem storage */ } }
  function fmtCep(c) { return c.length > 5 ? c.slice(0, 5) + '-' + c.slice(5) : c; }

  function regionOf(cep) {
    if (!cep || cep.length !== 8) return null;
    var n = parseInt(cep.slice(0, 5), 10);
    if (isNaN(n) || n < 1000) return null;
    if ((n >= 1000 && n <= 5999) || (n >= 8000 && n <= 8499) || (n >= 20000 && n <= 23799)) return { name: 'Rio e São Paulo (capitais)', min: 3, max: 5 };
    if (n <= 19999 || (n >= 20000 && n <= 28999) || (n >= 29000 && n <= 39999)) return { name: 'Sudeste', min: 4, max: 9 };
    if (n >= 40000 && n <= 65999) return { name: 'Nordeste', min: 5, max: 13 };
    if (n >= 66000 && n <= 69999) return { name: 'Norte', min: 5, max: 13 };
    if (n >= 70000 && n <= 76799) return { name: 'Centro-Oeste', min: 5, max: 13 };
    if (n >= 76800 && n <= 77999) return { name: 'Norte', min: 5, max: 13 };
    if (n >= 78000 && n <= 78899) return { name: 'Centro-Oeste', min: 5, max: 13 };
    if (n >= 78900 && n <= 78999) return { name: 'Norte', min: 5, max: 13 };
    if (n >= 79000 && n <= 79999) return { name: 'Centro-Oeste', min: 5, max: 13 };
    if (n >= 80000 && n <= 99999) return { name: 'Sul', min: 5, max: 13 };
    return null;
  }

  /* valor que decide se o frete e gratis: na pagina de produto, o preco da peca; no carrinho, o subtotal */
  function baseCents(box) {
    if (box.closest('.rs-frete-slot')) {
      var el = document.querySelector('.product__info-container .price-item--last') || document.querySelector('.product__info-container .price-item--regular');
      return Promise.resolve(el ? moneyAfterRS(el.textContent) : 0);
    }
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { return c.items_subtotal_price || 0; }).catch(function () { return 0; });
  }
  function priceSeg(base) { return base == null ? '' : (base >= FREE_FROM ? 'grátis' : FREIGHT); }

  function resultHTML(cep, base) {
    var r = regionOf(cep);
    if (!r) return '';
    var p = priceSeg(base);
    return '<strong>Frete Rápido' + (p ? ': ' + p : '') + '</strong><br>' + r.name + ': entre ' + r.min + ' e ' + r.max + ' dias úteis';
  }
  function freteLabel(cep, base) {
    var r = regionOf(cep);
    if (!r) return 'Calcular prazo de entrega';
    var p = priceSeg(base);
    return 'Frete Rápido' + (p ? ': ' + p : '') + ' · ' + r.min + ' a ' + r.max + ' dias úteis';
  }

  function freteHTML(fold) {
    var cep = readCep();
    if (!regionOf(cep)) cep = '';
    var body = `<div class='rs-frete__row'><input class='rs-frete__input' type='text' inputmode='numeric' autocomplete='postal-code' maxlength='9' placeholder='Digite seu CEP' aria-label='CEP' value='${fmtCep(cep)}'><button type='button' class='rs-frete__btn'>${cep ? 'Limpar' : 'Calcular'}</button></div><p class='rs-frete__foot'><a href='https://buscacepinter.correios.com.br/app/endereco/index.php' target='_blank' rel='noopener'>Não sei meu CEP</a></p><p class='rs-frete__out' aria-live='polite'>${resultHTML(cep)}</p>`;
    if (!fold) return `<div class='rs-frete'><div class='rs-frete__head'><span>Calcular prazo de entrega</span><span class='rs-frete__free'>Frete grátis a partir de R$${FREE_FROM / 100}</span></div><div class='rs-frete__body'>${body}</div></div>`;
    return `<div class='rs-frete rs-frete--fold${freteOpen ? ' is-open' : ''}'><button type='button' class='rs-frete__toggle' aria-expanded='${freteOpen ? 'true' : 'false'}'><span class='rs-frete__label'>${freteLabel(cep)}</span>${CHEV}</button><div class='rs-frete__body'${freteOpen ? '' : ' hidden'}>${body}</div></div>`;
  }

  function wireFrete(scope) {
    scope.querySelectorAll('.rs-frete:not([data-w])').forEach(function (box) {
      box.setAttribute('data-w', '1');
      var input = box.querySelector('.rs-frete__input');
      var btn = box.querySelector('.rs-frete__btn');
      var out = box.querySelector('.rs-frete__out');
      var label = box.querySelector('.rs-frete__label');
      var tg = box.querySelector('.rs-frete__toggle');
      var base = null;
      function digits() { return input.value.replace(/[^0-9]/g, '').slice(0, 8); }
      function sync() {
        var d = digits();
        input.value = fmtCep(d);
        btn.textContent = d && d === readCep() ? 'Limpar' : 'Calcular';
        if (label) label.textContent = freteLabel(readCep(), base);
      }
      /* busca o valor-base e mostra o frete (R$12 ou gratis) junto do prazo */
      function paint() {
        var c = readCep();
        if (!regionOf(c)) return;
        baseCents(box).then(function (b) {
          base = b;
          out.innerHTML = resultHTML(c, b);
          if (label) label.textContent = freteLabel(c, b);
        });
      }
      function calc() {
        if (btn.textContent === 'Limpar') {
          saveCep('');
          input.value = '';
          out.innerHTML = '';
          sync();
          input.focus();
          return;
        }
        var d = digits();
        if (!regionOf(d)) { out.innerHTML = 'Confira o CEP digitado.'; return; }
        saveCep(d);
        out.innerHTML = resultHTML(d, base);
        sync();
        paint();
      }
      if (tg) tg.addEventListener('click', function () {
        freteOpen = !freteOpen;
        box.classList.toggle('is-open', freteOpen);
        tg.setAttribute('aria-expanded', freteOpen ? 'true' : 'false');
        box.querySelector('.rs-frete__body').hidden = !freteOpen;
        if (freteOpen) input.focus();
      });
      input.addEventListener('input', sync);
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); calc(); } });
      btn.addEventListener('click', calc);
      paint();
    });
  }

  function injectFrete(root) {
    if (root.querySelector('.rs-frete')) return;
    var c = root.querySelector('.rs-coupon');
    if (c) {
      c.insertAdjacentHTML('beforebegin', freteHTML(true));
    } else {
      var t = couponTarget(root);
      if (!t) return;
      t.el.insertAdjacentHTML(t.pos, freteHTML(true));
    }
    wireFrete(root);
  }

  /* pagina de produto: o bloco .rs-frete-slot recebe o mesmo calculo, aberto */
  function injectSlots() {
    document.querySelectorAll('.rs-frete-slot').forEach(function (slot) {
      if (slot.querySelector('.rs-frete')) return;
      slot.innerHTML = freteHTML(false);
      wireFrete(slot);
    });
  }

  /* ---------- Campo de cupom (recolhido) ---------- */
  function fieldHTML() {
    return '<div class="rs-coupon rs-coupon--fold' + (couponOpen ? ' is-open' : '') + '">' +
      '<button class="rs-coupon__toggle" type="button" aria-expanded="' + (couponOpen ? 'true' : 'false') + '"><span>Tem um código ou cupom?</span>' + CHEV + '</button>' +
      '<div class="rs-coupon__body"' + (couponOpen ? '' : ' hidden') + '>' +
      '<div style="display:flex;gap:6px;">' +
      '<input class="rs-coupon-input" type="text" value="" placeholder="Digite o cupom de desconto" autocomplete="off" ' +
      'style="flex:1;min-width:0;padding:10px 12px;border:1px solid #cfd9e2;border-radius:8px;font:inherit;font-size:16px;text-transform:uppercase;color:#0b2a44;background:#fff;" />' +
      '<button class="rs-coupon-btn" type="button" ' +
      'style="padding:10px 18px;border:none;border-radius:8px;background:#0b2a44;color:#fff;font-weight:700;font-size:0.95rem;cursor:pointer;white-space:nowrap;">Aplicar</button>' +
      '</div>' +
      '<p class="rs-coupon-msg" style="margin:6px 2px 0;font-size:0.85rem;line-height:1.3;min-height:1em;color:#8fa4b2;"></p>' +
      '</div></div>';
  }

  function appliedHTML(code) {
    return '<div class="rs-coupon" style="margin:8px 0;">' +
      '<div style="display:flex;align-items:center;gap:8px;padding:10px 12px;background:#e3f4ea;border:1px solid #b7e0c7;border-radius:8px;font-weight:700;color:#17824b;font-size:0.9rem;">' +
      '<span>✓ Cupom <span style="background:#17824b;color:#fff;border-radius:4px;padding:1px 7px;letter-spacing:.5px;">' + code + '</span> aplicado</span>' +
      '<a class="rs-coupon-change" href="#" style="margin-left:auto;font-weight:600;color:#4a6178;font-size:0.82rem;">remover</a>' +
      '</div></div>';
  }

  function couponTarget(root) {
    var items = root.querySelector('cart-drawer-items');
    if (items) return { el: items, pos: 'afterend' };
    var footer = root.querySelector('.drawer__footer, .cart-drawer__footer');
    if (footer) return { el: footer, pos: 'afterbegin' };
    var ctas = root.querySelector('.cart__ctas');
    if (ctas) return { el: ctas, pos: 'beforebegin' };
    var checkout = root.querySelector('[name="checkout"]');
    if (checkout) {
      var box = checkout.closest('div') || checkout.parentElement;
      if (box) return { el: box, pos: 'beforebegin' };
    }
    return null;
  }

  function injectCoupon(root) {
    if (root.querySelector('.rs-coupon')) return;
    var t = couponTarget(root);
    if (!t) return;
    t.el.insertAdjacentHTML(t.pos, appliedCode ? appliedHTML(appliedCode) : fieldHTML());
    wireCoupon(root);
  }

  function wireCoupon(root) {
    var tg = root.querySelector('.rs-coupon__toggle');
    if (tg) tg.addEventListener('click', function () {
      couponOpen = !couponOpen;
      var wrap = tg.parentElement;
      var body = wrap.querySelector('.rs-coupon__body');
      wrap.classList.toggle('is-open', couponOpen);
      tg.setAttribute('aria-expanded', couponOpen ? 'true' : 'false');
      body.hidden = !couponOpen;
      if (couponOpen) { var i = body.querySelector('.rs-coupon-input'); if (i) i.focus(); }
    });
    var btn = root.querySelector('.rs-coupon-btn');
    if (btn) btn.addEventListener('click', function () { applyCoupon(root); });
    var input = root.querySelector('.rs-coupon-input');
    if (input) input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); applyCoupon(root); }
    });
    var change = root.querySelector('.rs-coupon-change');
    if (change) change.addEventListener('click', function (e) {
      e.preventDefault();
      removeCoupon(root);
    });
  }

  async function removeCoupon(root) {
    var change = root.querySelector('.rs-coupon-change');
    if (change) change.textContent = 'removendo...';
    try {
      await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: '' }) });
    } catch (e) { /* ignora */ }
    appliedCode = null;
    await refresh();
  }

  async function applyCoupon(root) {
    var input = root.querySelector('.rs-coupon-input');
    var msg = root.querySelector('.rs-coupon-msg');
    if (!input) return;
    var code = (input.value || '').trim();
    if (!code) { if (msg) { msg.textContent = 'Digite um cupom.'; msg.style.color = '#c23a3a'; } return; }
    if (msg) { msg.textContent = 'Validando...'; msg.style.color = '#8fa4b2'; }
    try {
      var r = await fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', { headers: { 'Accept': 'application/json' } });
      var cart = JSON.parse(await r.text());
      var ok = (cart.discount_codes || []).some(function (d) {
        return d.applicable && (d.code || '').toUpperCase() === code.toUpperCase();
      });
      if (ok) {
        appliedCode = code.toUpperCase();
        couponOpen = false;
        await refresh();
      } else if (msg) {
        msg.textContent = 'Cupom inválido ou não aplicável a este carrinho.';
        msg.style.color = '#c23a3a';
      }
    } catch (e) {
      if (msg) { msg.textContent = 'Não deu pra validar agora. Tente de novo.'; msg.style.color = '#c23a3a'; }
    }
  }

  // Na /cart recarrega a página (o Dawn não expõe re-render simples do footer
  // com desconto novo); na gaveta troca só a seção.
  async function refresh() {
    if (document.querySelector('#main-cart-footer')) { window.location.reload(); return; }
    try {
      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var res = await fetch(rootUrl + '?sections=cart-drawer');
      var data = await res.json();
      var html = data['cart-drawer'];
      if (!html) return;
      var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#CartDrawer');
      var current = document.querySelector('#CartDrawer');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
    } catch (e) { /* silencioso */ }
  }

  /* ---------- Orquestração ---------- */
  function apply() {
    observers.forEach(function (o) { o.disconnect(); });
    roots().forEach(function (root) {
      var velha = root.querySelector('#rs-ship-bar');
      if (velha) velha.remove();
      injectCoupon(root);
      injectFrete(root);
      injectTotalStrike(root);
    });
    observers.forEach(function (o, i) {
      var r = roots()[i];
      if (r) o.observe(r, { childList: true, subtree: true });
    });
  }

  async function syncFromCart() {
    try {
      var cart = await (await fetch('/cart.js')).json();
      var applied = (cart.discount_codes || []).filter(function (d) { return d.applicable; });
      appliedCode = applied.length ? (applied[0].code || '').toUpperCase() : null;
    } catch (e) { /* ignora */ }
    apply();
  }

  function init() {
    injectSlots();
    var rs = roots();
    if (!rs.length) return;
    observers = rs.map(function () { return new MutationObserver(function () { apply(); }); });
    syncFromCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
